import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useHistory } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { Backdrop, CircularProgress } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const useStyles = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: '#FFFFFF',
    },
    avatar: {
        margin: theme.spacing(1),
        width: '210px',
        height: '289px',
    },
    input: {
        fontFamily: ['Poppins', 'regular'].join(','),
        backgroundColor: 'white',
        disableUnderline: true,
        borderRadius: '4px',
        height: '49px',
        fontSize: '16px',
        width: '340px',
        [theme.breakpoints.down(768)]: {
            width: 'auto',
        },
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        borderRadius: '12px',
        backgroundColor: '#00BBFF',
        textTransform: 'none',
        fontFamily: ['Poppins', 'medium'].join(','),
        fontSize: '26px',
        width: '289px',
        height: '64px',
        '&:hover': {
            backgroundColor: 'white',
            color: '#00BBFF',
        },
        [theme.breakpoints.down(768)]: {
            width: 'auto',
        },
    },
    header: {
        color: 'inherit',
        fontFamily: ['Poppins', 'regular'].join(','),
        textTransform: 'uppercase',
        fontSize: '36px',
        textAlign: 'center',
    },
    label: {
        color: 'inherit',
        marginTop: theme.spacing(2),
        fontFamily: ['Poppins', 'regular'].join(','),
        fontSize: '17px',
        fontWeight: 400,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    signup: {
        margin: theme.spacing(2),
        borderRadius: '12px',
        backgroundColor: '##FFFFFF',
        textTransform: 'none',
        fontFamily: ['Poppins', 'medium'].join(','),
        fontSize: '18px',
        width: '234px',
        height: '56px',
        [theme.breakpoints.down(768)]: {
            width: 'auto',
        },
    },
}));

export default function SignUp() {
    const classes = useStyles();
    const history = useHistory();
    const [error, setError] = React.useState('');
    const [showError, setShowError] = React.useState(false);
    const [email, setEmail] = React.useState<string>('');
    const [code, setCode] = React.useState<string>('');
    const [loading, setLoading] = React.useState(false);

    function Alert(alertProps: AlertProps) {
        // eslint-disable-next-line react/jsx-props-no-spreading
        return <MuiAlert elevation={6} variant="filled" {...alertProps} />;
    }

    const handleSubmit = (event: React.FormEvent<HTMLButtonElement>) => {
        event.preventDefault();
        setLoading(true);
        Auth.confirmSignUp(email, code)
            .then(() => {
                history.push('/signed');
            })
            .catch((err) => {
                setLoading(false);
                setShowError(true);
                setError(err.message);
                return err.message;
            });
    };

    return (
        <>
            <Button
                onClick={() => {
                    history.push('/signup');
                }}
                endIcon={<ArrowBackIcon style={{ fontSize: 48, color: '#005FB3' }} />}
            />
            <Container maxWidth="xs">
                <Backdrop className={classes.backdrop} open={loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar
                    open={showError}
                    key="topcenter"
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    autoHideDuration={6000}
                    onClose={() => {
                        setShowError(false);
                    }}
                >
                    <Alert
                        onClose={() => {
                            setShowError(false);
                        }}
                        severity="error"
                    >
                        {error}
                    </Alert>
                </Snackbar>
                <CssBaseline />
                <div className={classes.paper}>
                    <Avatar variant="square" className={classes.avatar} src="/logo.png" />
                    <Typography className={classes.header}>Confirm Register</Typography>
                    <form noValidate>
                        <FormGroup className={classes.form}>
                            <TextField
                                InputProps={{
                                    className: classes.input,
                                }}
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Email"
                                name="email"
                                type="email"
                                autoComplete="email"
                                autoFocus
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <TextField
                                InputProps={{
                                    className: classes.input,
                                }}
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="code"
                                label="Confirmation Code"
                                name="code"
                                type="string"
                                autoFocus
                                onChange={(e) => setCode(e.target.value)}
                            />
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                onClick={handleSubmit}
                                className={classes.submit}
                            >
                                Confirm
                            </Button>
                        </FormGroup>
                    </form>
                </div>
            </Container>
        </>
    );
}
